import Vue from 'vue';

Vue.component('order-integration-badges', require('./components/orders/order-integration-badges.vue').default);
Vue.component('order-integration-single-badge', require('./components/orders/order-integration-single-badge.vue').default);
